import '../jquery'
$(document).ready(function () {
    $(document).on('change', "input[name='domain[kind]']", function () {
        var kind = $(this).val();
        switch (kind) {
            case 'alias':
                $('#domain_alias_for').prop('disabled', false);
                $('select').selectpicker('refresh');
                break;
            case 'domain':
                $('#domain_alias_for').prop('disabled', true);
                $('#domain_alias_for').val(null);
                $('select').selectpicker('refresh');
                break;
        }
    });

    $(document).on('change', "input.domain_setting", function () {
      $.ajax({
        url: "/mailadmin/domains/" + $(this).data('domain') + "/change_setting.js",
        type: "POST",
        data: {
          setting: $(this).data('setting'),
          value: $(this).prop('checked')
        },
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        }
      });
    });

});
